export enum EntryMode {
    NONE = 0,
    CLICKER,
    MANUAL
}
